<template>
  <div class="page dreaming">
    <div class="btn-wapper">
      <div class="btn" @click="handleScanCode">扫一扫</div>
    </div>
    <div class="header">
      <img src="../../assets/images/activity/dream/header.png">
    </div>
    <div class="theme">
      <div class="theme-host">
        <img src="../../assets/images/activity/dream/title-icon-1.png">
        <span>易加网联合博修e路行推出</span>
        <img src="../../assets/images/activity/dream/title-icon-2.png">
      </div>
      <div class="theme-title">
        <img src="../../assets/images/activity/dream/theme-1.png">
      </div>
      <div class="theme-info">四重福利送不停</div>
      <div class="theme-time">活动时间 2020.7.1-12.31</div>
    </div>

    <div class="banner">
      <img src="../../assets/images/activity/dream/banner.png">
    </div>

    <div class="rule">
      <div class="rule-wrapper">
        <div class="color-bar">
          <span>1</span>
          <span>扫码获50积分</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-prize">
            <img style="width: 70%"  src="../../assets/images/activity/dream/rule-1.png">
          </div>
          <div class="rule-content-info">扫描博世产品码<br>即可获得50积分</div>
        </div>
      </div>

      <div class="rule-wrapper">
        <div class="color-bar">
          <span>2</span>
          <span>点亮地图免费拿好礼</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-icon padding-top-10">
            ×6期
          </div>
          <div class="rule-content-prize">
            <img src="../../assets/images/activity/dream/rule-2.png">
          </div>
          <div class="rule-content-info">完成博世地标点亮<br>6期免费送</div>
          <div class="rule-content-remark base-blue">* 集满100点心愿值可完成点亮</div>
        </div>
      </div>

      <div class="rule-wrapper">
        <div class="color-bar">
          <span>3</span>
          <span>扫码PK积分翻倍</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-icon padding-top-10">
            ×2轮
          </div>
          <div class="rule-content-prize">
            <img src="../../assets/images/activity/dream/rule-3.png">
          </div>
          <div class="rule-content-info">当月扫码PK最佳<br> 积分翻倍</div>
          <div class="rule-content-remark base-blue">* 当月通过扫码获取的积分翻倍</div>
        </div>
      </div>

      <div class="rule-wrapper">
        <div class="color-bar">
          <span>4</span>
          <span>百万积分免费送</span>
        </div>

        <div class="rule-content">
          <div class="rule-content-icon">
            年度<br>大奖
          </div>
          <div class="rule-content-prize">
            <img src="../../assets/images/activity/dream/rule-4.png">
          </div>
          <div class="rule-content-info">全年扫码量<br>TOP5修理厂奖励</div>
          <div class="rule-content-remark base-blue">* 需完成6个博世地标点亮</div>
        </div>
      </div>
    </div>

    <div class="guide">
      <div class="guide-title">
        <img src="../../assets/images/activity/dream/guide-title-icon1.png">
        <span>第一重福利 扫码获50积分</span>
        <img src="../../assets/images/activity/dream/guide-title-icon2.png">
      </div>
      <div class="guide-content">
        <img src="../../assets/images/activity/dream/guide-1.png">
        <div class="guide-btn">扫一扫</div>
        <div class="guide-info base-blue">* 扫描博世产品码即可获得50积分</div>
      </div>

      <div class="guide-title">
        <img src="../../assets/images/activity/dream/guide-title-icon1.png">
        <span>第二重福利 点亮地图免费拿好礼</span>
        <img src="../../assets/images/activity/dream/guide-title-icon2.png">
      </div>

      <div class="guide-map">
        <!-- 中国总部 start-->
        <div class="map-icon map-icon-one">
          <img v-if="clientRecordList[0] && clientRecordList[0].landmarkLight" class="map-icon-light" src="../../assets/images/activity/dream/icon-light.png">
          <img src="../../assets/images/activity/dream/map-icon-1.png">
        </div>
        <div class="map-site map-site-one" @click="handleViewDetail('1')">
          <span :class="{ 'site-active': period >= 1 }">1.中国总部</span>
          <img v-if="period >= 1" src="../../assets/images/activity/dream/icon-play-light.gif">
          <img v-else src="../../assets/images/activity/dream/icon-play-dark.gif">
        </div>
        <!-- 中国总部 end-->

        <!-- 南京工厂 start-->
        <div class="map-icon map-icon-two">
          <img v-if="clientRecordList[1] && clientRecordList[1].landmarkLight" class="map-icon-light" src="../../assets/images/activity/dream/icon-light.png">
          <img src="../../assets/images/activity/dream/map-icon-2.png">
        </div>
        <div class="map-site map-site-two" @click="handleViewDetail('2')">
          <span :class="{ 'site-active': period >= 2 }">2.南京工厂</span>
          <img v-if="period >= 2" src="../../assets/images/activity/dream/icon-play-light.gif">
          <img v-else src="../../assets/images/activity/dream/icon-play-dark.gif">
        </div>
        <!-- 南京工厂 end-->

        <!-- 博世车联 start-->
        <div class="map-icon map-icon-three">
          <img v-if="clientRecordList[2] && clientRecordList[2].landmarkLight" class="map-icon-light" src="../../assets/images/activity/dream/icon-light.png">
          <img src="../../assets/images/activity/dream/map-icon-3.png">
        </div>
        <div class="map-site map-site-three" @click="handleViewDetail('3')">
          <span :class="{ 'site-active': period >= 3 }">3.博世车联</span>
          <img v-if="period >= 3" src="../../assets/images/activity/dream/icon-play-light.gif">
          <img v-else src="../../assets/images/activity/dream/icon-play-dark.gif">
        </div>
        <!-- 博世车联 end-->

        <!-- 试车中心 start-->
        <div class="map-icon map-icon-four">
          <img v-if="clientRecordList[3] && clientRecordList[3].landmarkLight" class="map-icon-light" src="../../assets/images/activity/dream/icon-light.png">
          <img src="../../assets/images/activity/dream/map-icon-4.png">
        </div>
        <div class="map-site map-site-four" @click="handleViewDetail('4')">
          <span :class="{ 'site-active': period >= 4 }">4.试车中心</span>
          <img v-if="period >= 4" src="../../assets/images/activity/dream/icon-play-light.gif">
          <img v-else src="../../assets/images/activity/dream/icon-play-dark.gif">
        </div>
        <!-- 试车中心 end-->

        <!-- 工业4.0 start-->
        <div class="map-icon map-icon-five">
          <img v-if="clientRecordList[4] && clientRecordList[4].landmarkLight" class="map-icon-light" src="../../assets/images/activity/dream/icon-light.png">
          <img src="../../assets/images/activity/dream/map-icon-5.png">
        </div>
        <div class="map-site map-site-five" @click="handleViewDetail('5')">
          <span :class="{ 'site-active': period >= 5 }">5.工业4.0</span>
          <img v-if="period >= 5" src="../../assets/images/activity/dream/icon-play-light.gif">
          <img v-else src="../../assets/images/activity/dream/icon-play-dark.gif">
        </div>
        <!-- 工业4.0 end-->

        <!-- 研发中心 start-->
        <div class="map-icon map-icon-six">
          <img v-if="clientRecordList[5] && clientRecordList[5].landmarkLight" class="map-icon-light" src="../../assets/images/activity/dream/icon-light.png">
          <img src="../../assets/images/activity/dream/map-icon-5.png">
        </div>
        <div class="map-site map-site-six" @click="handleViewDetail('6')">
          <span :class="{ 'site-active': period >= 6 }">6.研发中心</span>
          <img v-if="period >= 6" src="../../assets/images/activity/dream/icon-play-light.gif">
          <img v-else src="../../assets/images/activity/dream/icon-play-dark.gif">
        </div>
        <!-- 研发中心 end-->

        <img src="../../assets/images/activity/dream/guide-2.png">
      </div>

      <div class="guide-content">
        <div class="guide-info">
          <div class="guide-info-title">
            <img src="../../assets/images/activity/dream/guide-icon-1.png">
            <span class="base-blue">扫码集心愿值点亮博世地标</span>
            <img src="../../assets/images/activity/dream/guide-icon-2.png">
          </div>
          <div class="base-blue">免费领好礼</div>
          <div>当月集满100点心愿值即可完成点亮</div>
          <div class="guide-info-title">
            <img src="../../assets/images/activity/dream/guide-icon-3.png">
            <span class="base-blue">获取心愿值tips</span>
            <img src="../../assets/images/activity/dream/guide-icon-4.png">
          </div>
          <div class="guide-way">
            <span>1.扫码1次获得1点</span>
            <span>2.邀请5个好友助力获得1点</span>
          </div>

          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in cardList" :key="index">
              <div class="guide-card" :class="{ 'guide-card-active': index === period - 1 }" :style="`background-image: linear-gradient(${item.top}, ${item.bottom});`">
                <div class="card-period">{{ item.period }}</div>
                <div class="card-image">
                  <img :src="item.imgUrl">
                </div>
                <div class="card-title">{{ item.title }}</div>
                <div class="card-prize">{{ item.prize }}</div>
                <div class="card-btn" :class="{ 'card-btn-active': hasCompliance(index) === '点击领取' }" @click="handleTakeGift(index)">{{ hasCompliance(index) }}</div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>

          <div class="progress-bar">
            <div v-if="period >= 1 && period <= 6" class="progress-bubble" ref="bubble" :style="`padding-left:${calcWidth}px`">
              <span>进行中</span>
            </div>
            <div v-for="(item, index) in processBarList" :key="index">
              <div class="progress-bar-image" :class="{ 'progress-bar-active': index <= (period - 1) }">
                <span v-html="item.local"></span>
                <img :src="item.imgUrl">
                <div v-if="index !== (processBarList.length - 1)" class="arrow">
                  <img v-if="index <= (period - 1)" src="../../../src/assets/images/activity/dream/arrow-light.png">
                  <img v-else src="../../../src/assets/images/activity/dream/arrow-dark.png">
                </div>
                <div v-if="index <= (period - 1)" class="progress-bar-mark"></div>
              </div>
              <div class="base-blue">{{ item.period }}</div>
            </div>
          </div>

          <div class="guide-info-title">
            <img src="../../assets/images/activity/dream/guide-icon-3.png">
            <span class="base-blue">
              本月已获得
              <span style="color: #ff4050; vertical-align: baseline;">{{ calcWishQty }}点</span>
              心愿值
            </span>
            <img src="../../assets/images/activity/dream/guide-icon-4.png">
            <span class="base-blue">
              还差
              <span style="color: #ff4050; vertical-align: baseline;">{{ 100 - calcWishQty > 0 ? 100 - calcWishQty : 0}}点</span>
              心愿值即可点亮
            </span>
          </div>
          <div class="btn-wrapper">
            <div class="guide-btn width-130" @click="handleScanCode">扫一扫</div>
            <div class="guide-btn width-130" @click="handleSupport">喊好友助力</div>
          </div>
          <div class="guide-info-title" style="padding-bottom: 20px">
            <img src="../../assets/images/activity/dream/guide-icon-3.png">
            <span class="base-blue">
              已有
              <span style="color: #ff4050; vertical-align: baseline;">{{ calcSupportQty }}个</span>
              好友助力
            </span>
            <img src="../../assets/images/activity/dream/guide-icon-4.png">
            <span class="base-blue">
              还差
              <span style="color: #ff4050; vertical-align: baseline;">{{ 5 - calcSupportQty % 5 }}个</span>
              好友，获得1点心愿值
            </span>
          </div>

          <div class="guide-share">
            <div class="guide-share-tips">
              <img src="../../assets/images/activity/dream/share-icon-1.png">
              <div>分享链接</div>
            </div>
            <img src="../../assets/images/activity/dream/arrow-3.png">
            <div class="guide-share-tips">
              <img src="../../assets/images/activity/dream/share-icon-2.png">
              <div>好友点击</div>
            </div>
            <img src="../../assets/images/activity/dream/arrow-3.png">
            <div class="guide-share-tips">
              <img src="../../assets/images/activity/dream/share-icon-3.png">
              <div>获得心愿值</div>
            </div>
          </div>
          <div class="base-blue" style="padding: 10px 0;">礼品数量有限，领完为止</div>
        </div>
      </div>

      <div class="guide-title">
        <img src="../../assets/images/activity/dream/guide-title-icon1.png">
        <span>第三重福利 扫码PK积分翻倍</span>
        <img src="../../assets/images/activity/dream/guide-title-icon2.png">
      </div>

      <div class="guide-content">
        <div class="guide-info">
          <div class="guide-info-title">
            <img src="../../assets/images/activity/dream/guide-icon-1.png">
            <span class="base-blue">扫码参与率PK</span>
            <img src="../../assets/images/activity/dream/guide-icon-2.png">
          </div>
          <div class="base-blue">获胜最佳城市积分翻倍</div>
          <div class="rank rank-first">
            <div v-if="pkRankingList[0]">{{ pkRankingList[0].cityName || '暂无' }}</div>
          </div>
          <div class="rank rank-second">
            <div v-if="pkRankingList[1]">{{ pkRankingList[1].cityName || '暂无' }}</div>
          </div>
          <div class="rank rank-third">
            <div v-if="pkRankingList[2]">{{ pkRankingList[2].cityName || '暂无' }}</div>
          </div>
        </div>
      </div>

      <div class="guide-title">
        <img src="../../assets/images/activity/dream/guide-title-icon1.png">
        <span>第四重福利 百万积分免费送</span>
        <img src="../../assets/images/activity/dream/guide-title-icon2.png">
      </div>

      <div class="guide-content">
        <div class="guide-info">
          <div class="guide-info-title">
            <img src="../../assets/images/activity/dream/guide-icon-1.png">
            <span class="base-blue">年度大奖</span>
            <img src="../../assets/images/activity/dream/guide-icon-2.png">
          </div>
          <img class="icon-prize" src="../../assets/images/activity/dream/icon-prize.png">
          <div>
            <div class="base-blue">
              全年扫码量TOP5修理厂各奖励
              <span style="color: #ff4050; vertical-align: baseline;">1,000,000积分</span>
            </div>
            <div class="base-blue">（需完成6个博世地标点亮）</div>
          </div>
        </div>
      </div>

      <div class="guide-title">
        <img src="../../assets/images/activity/dream/guide-title-icon1.png">
        <span>活动细则</span>
        <img src="../../assets/images/activity/dream/guide-title-icon2.png">
      </div>

      <div class="guide-content activity-details">
        <div>
          <span style="font-weight: 600">参与对象：</span>
          所有博世易加网IAM修理厂
        </div>
        <div>
          <span style="font-weight: 600">活动时间：</span>
          2020年7月1日-12月31日
        </div>
        <div>
          <span style="font-weight: 600">活动细则：</span>
          <p class="activity-title">1、第一重福利</p>
          <p>通过扫一扫博世产品码获得50积分，可重复累计获得；</p>
          <p class="activity-title">2、第二重福利</p>
          <p>活动分6期进行，每期点亮当月“博世地标”即可免费领取奖励，可通过扫码或邀请好友助力点亮，一次扫码或成功邀请5个好友助力获1点心愿值（每期单个好友限助力1次）。满足100点心愿值后自动完成点亮，免费领取好礼。数量有限，礼品中博世T恤尺码随机发，以实际库存为准，每个用户当月限领一次；</p>
          <p class="activity-title">3、第三重福利</p>
          <p>PK共分为2轮，第一轮为：7-9月各城市的扫码参与率进行PK；第二轮为：10-12月各城市的实际扫码参与率进行PK。当月PK结束后，最佳城市获得积分翻倍！（当月通过扫码获得的积分翻倍）</p>
          <p class="activity-title">4、第四重福利</p>
          <p>全年扫码数最多的top5，且点亮6个博世地标修理厂会员，奖励1,000,000易加积分。</p>
        </div>
        <div style="padding-top:10px">
          <span style="font-weight: 600">礼品发放:</span>
          <p>实物奖品：所有实物礼品与其他最近的积分兑换订单一起发出。</p>
          <p>积分奖品：当月活动结束后，次月初充值到账。</p>
        </div>
      </div>
    </div>

    <van-popup v-model="popShow" :close-on-click-overlay="false">
      <div v-if="popType === 'text'" class="pop-content">
        <div class="pop-content-title">{{ pop.title }}</div>
        <div class="pop-content-img">
          <img :src="pop.imgUrl">
        </div>
        <div class="pop-content-info">{{ pop.content }}</div>
      </div>

      <div v-if="popType === 'activity'" class="pop-content">
        <div class="pop-header">
          <img src="../../assets/images/activity/dream/pop-icon-1.png">
          <span>{{ pop.iconText }}</span>
          <img src="../../assets/images/activity/dream/pop-icon-2.png">
        </div>
        <div class="pop-content-info">
          <div class="font-size-16 pop-info-title">{{ pop.title }}</div>
          <div class="font-size-16 pop-info-content" v-html="pop.content"></div>
        </div>
        <div class="pop-btn" @click="handleSupportInvite">{{ pop.btnText }}</div>
      </div>

      <div v-if="popType === 'result'" :class="{'pop-content': true, 'pop-content-result': popType === 'result'}">
        <div :class="{'pop-header': true, 'pop-header-result': popType === 'result'}">
          <img src="../../assets/images/activity/dream/pop-icon-3.png">
        </div>
        <div class="pop-content-info">
          <div class="font-size-16 pop-info-title" v-html="pop.title"></div>
          <div class="font-size-16 pop-info-content" v-html="pop.content"></div>
        </div>
      </div>

      <div class="pop-close" @click="popShow = false">
        <img src="../../assets/images/activity/form-verification-off.png">
      </div>
    </van-popup>

    <van-overlay :show="showOverlay" @click="showOverlay = false" z-index="99">
      <div class="overlay-wrapper">
        <div>
          点击页面右上角分享助力<img class="arrow" src="../../assets/images/extra-style/arrow.png">
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'ActivityDreaming',
  components: {
    swiper,
    swiperSlide
  },
  created () {
    this.init()
  },
  mounted () {
    this.calcWidth = this.$refs.bubble.clientWidth / 6 * (this.period - 1)
    this.getCurrentMonth()
    this.initWxJsSdk()
  },
  computed: {
    calcWishQty () {
      if (this.clientRecordList.length && this.clientRecordList[this.period - 1]) {
        return Number(this.clientRecordList[this.period - 1].wishQty)
      } else {
        return 0
      }
    },
    calcSupportQty () {
      if (this.clientRecordList.length && this.clientRecordList[this.period - 1]) {
        return Number(this.clientRecordList[this.period - 1].supportQty)
      } else {
        return 0
      }
    }
  },
  watch: {
    'period' () {
      this.calcWidth = this.$refs.bubble.clientWidth / 6 * (this.period - 1)
    }
  },
  data () {
    return {
      isMounted: false,
      clientInfo: null,
      clientRecordList: [
        { giftTake: 0, landmarkLight: 0, periodCode: '202007', scanQty: 0, supportQty: 0, wishQty: 0 },
        { giftTake: 0, landmarkLight: 0, periodCode: '202008', scanQty: 0, supportQty: 0, wishQty: 0 },
        { giftTake: 0, landmarkLight: 0, periodCode: '202009', scanQty: 0, supportQty: 0, wishQty: 0 },
        { giftTake: 0, landmarkLight: 0, periodCode: '202010', scanQty: 0, supportQty: 0, wishQty: 0 },
        { giftTake: 0, landmarkLight: 0, periodCode: '202011', scanQty: 0, supportQty: 0, wishQty: 0 },
        { giftTake: 0, landmarkLight: 0, periodCode: '202012', scanQty: 0, supportQty: 0, wishQty: 0 }
      ],
      period: 1,
      calcWidth: 0,
      cardList: [
        { bottom: '#ff4050', top: '#ff874a', period: '第一期', imgUrl: require('../../../src/assets/images/activity/dream/prize-1.jpg'), title: '易加T恤', prize: '价值4800积分' },
        { bottom: '#ffb504', top: '#fdd513', period: '第二期', imgUrl: require('../../../src/assets/images/activity/dream/prize-2.jpg'), title: '洗车毛巾六件套', prize: '价值3800积分' },
        { bottom: '#6704ff', top: '#ae11fe', period: '第三期', imgUrl: require('../../../src/assets/images/activity/dream/prize-3.jpg'), title: '易加足球', prize: '价值3000积分' },
        { bottom: '#298ef6', top: '#26c2eb', period: '第四期', imgUrl: require('../../../src/assets/images/activity/dream/prize-4.jpg'), title: '高尔夫雨伞', prize: '价值3300积分' },
        { bottom: '#9e05b5', top: '#da55ee', period: '第五期', imgUrl: require('../../../src/assets/images/activity/dream/prize-2.jpg'), title: '洗车毛巾', prize: '价值3800积分' },
        { bottom: '#298ef6', top: '#26c2eb', period: '第六期', imgUrl: require('../../../src/assets/images/activity/dream/prize-5.jpg'), title: '易加工具箱', prize: '价值5900积分' }
      ],
      processBarList: [
        { period: '第一期', imgUrl: require('../../../src/assets/images/activity/dream/process-1.png'), local: '中国<br>总部' },
        { period: '第二期', imgUrl: require('../../../src/assets/images/activity/dream/process-2.png'), local: '南京<br>工厂' },
        { period: '第三期', imgUrl: require('../../../src/assets/images/activity/dream/process-3.png'), local: '博世<br>车联' },
        { period: '第四期', imgUrl: require('../../../src/assets/images/activity/dream/process-4.png'), local: '试车<br>中心' },
        { period: '第五期', imgUrl: require('../../../src/assets/images/activity/dream/process-5.png'), local: '工业<br>4.0' },
        { period: '第六期', imgUrl: require('../../../src/assets/images/activity/dream/process-6.png'), local: '研发<br>中心' }
      ],
      swiperOption: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 10,
        initialSlide: this.getInitialSlide(),
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      showOverlay: false,
      pkRankingList: [],
      popShow: false,
      popType: '',
      pop: {
        title: '',
        content: '',
        imgUrl: '',
        iconText: '',
        btnText: ''
      },
      wxReady: false
    }
  },
  methods: {
    init () {
      this.clientInfo = userUtils.getClientInfo()
      if (this.clientInfo) {
        this.queryDreamingActivityRecord()
        this.queryPKRanking()
      }
    },
    getInitialSlide () {
      let period = new Date().getMonth() + 1 - 7
      let index
      if (period >= 1 && period < 3) {
        index = 0
      } else if (period >= 3 && period < 4) {
        index = 1
      } else if (period >= 4 && period < 5) {
        index = 2
      } else if (period >= 5 && period < 6) {
        index = 3
      } else if (period >= 6) {
        index = 3
      }
      return index
    },
    // 初始化微信jssdk
    initWxJsSdk () {
      // console.log(window.__wxjs_is_wkwebview)
      // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }

      let index = this.period - 1
      if (index < 0) index = 0
      const periodCode = this.clientRecordList[index].periodCode || ''
      let clientId = ''
      let clientName = ''
      if (this.clientInfo) {
        clientId = this.clientInfo.clientId
        clientName = this.clientInfo.clientName
      }
      const url = `${document.location.origin}/v2/activity/dreaming-support?clientId=${clientId}&periodCode=${periodCode}&clientName=${encodeURIComponent(clientName)}`
      const appMessageShare = {
        title: '梦想地图活动', // 分享标题
        desc: '梦想地图活动，助力赢好礼火热进行中', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/dreaming-map.jpg', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '易加范活动', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/dreaming-map.jpg', // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    },
    // 获取当前期
    getCurrentMonth () {
      let currentMonth = new Date().getMonth()
      this.period = currentMonth + 1 - 7 + 1
      if (this.period < 0) {
        this.period = 0
      }
    },
    // 当前用户活动参与度
    queryDreamingActivityRecord () {
      activityApi.queryDreamingActivityRecord().then(res => {
        if (res.data.resultCode === '0') {
          const recordList = res.data.resultData.clientRecordList || []
          this.clientRecordList.forEach((item, index) => {
            recordList.forEach(childItem => {
              if (item.periodCode === childItem.periodCode) {
                this.$set(this.clientRecordList, index, childItem)
                // this.clientRecordList[index] = childItem
              }
            })
          })
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 查询PK排名
    queryPKRanking () {
      activityApi.queryPKRanking().then(res => {
        if (res.data.resultCode === '0') {
          this.pkRankingList = res.data.resultData.pkRanking.slice(0, 3)
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    hasCompliance (index) {
      let record = this.clientRecordList[index]
      if (index > this.period - 1) {
        return '未开始'
      } else if (record.landmarkLight === 1 && record.giftTake === 0) {
        return '点击领取'
      } else if (!record || record.landmarkLight === 0) {
        return '未达标'
      } else {
        return '已领取'
      }
    },
    handleViewDetail (type) {
      this.popShow = true
      this.popType = 'text'
      switch (type) {
        case '1':
          this.pop.title = '博世中国总部'
          this.pop.content = '博世中国总部大楼坐落于上海，于2011年4月投入使用，是全亚太最大的区域总部。博世在中国拥有超过60家独立子公司，超过20个技术研发中心，超过6万名员工，是除德国本土以外雇佣人数最多的地区。'
          this.pop.imgUrl = require('../../../src/assets/images/activity/dream/pop-1.jpg')
          break
        case '2':
          this.pop.title = '博世南京工厂'
          this.pop.content = '2013年落成投产的南京工厂专注于制动部件和检测设备的研发生产。2014年第一千万套刹车片在博世南京下线，标志着博世本土化生产登上一个新台阶。'
          this.pop.imgUrl = require('../../../src/assets/images/activity/dream/pop-2.jpg')
          break
        case '3':
          this.pop.title = '北京博世车联'
          this.pop.content = '2012年，博世车联首家直营店在北京开业，致力于提供高品质、可信赖的汽车保养维修服务。'
          this.pop.imgUrl = require('../../../src/assets/images/activity/dream/pop-3.jpg')
          break
        case '4':
          this.pop.title = '博世（呼伦贝尔）汽车测试技术中心'
          this.pop.content = '牙克石（满语）意为“要塞”之意，素有“中国森林工业之都”、“冰雪之乡”的美誉。低至-45°的严寒测试天气，保证博世产品在极端条件下的优异表现！'
          this.pop.imgUrl = require('../../../src/assets/images/activity/dream/pop-4.jpg')
          break
        case '5':
          this.pop.title = '博世工业4.0创新技术中心'
          this.pop.content = '博世在工业4.0方面实行双重战略：既是领先的技术践行者，也是卓越的解决方案供应商。目前博世全球在280余家工厂实践着70余个工业4.0解决方案，在中国的9大生产基地开展了13个工业4.0项目。'
          this.pop.imgUrl = require('../../../src/assets/images/activity/dream/pop-5.jpg')
          break
        case '6':
          this.pop.title = '博世研发中心'
          this.pop.content = '博世雨刮工厂/检测设备研发中心，博世百年雨刮历史，不断创新，年产超700w支雨刮。'
          this.pop.imgUrl = require('../../../src/assets/images/activity/dream/pop-6.jpg')
          break
      }
    },
    // 领取礼品
    handleTakeGift (index) {
      if (this.hasCompliance(index) !== '点击领取') return
      const data = {
        periodCode: this.clientRecordList[index].periodCode
      }
      activityApi.dreamingTakeGift(data).then(res => {
        if (res.data.resultCode === '0') {
          let giftLimit = res.data.resultData.action || ''
          if (giftLimit === 'overLimit') {
            this.popShow = true
            this.popType = 'result'
            this.pop.title = '<span style="color:#000; font-size: 20px; font-weight: 600;">抱歉！</span>'
            this.pop.content = `当月好礼已被领完`
          } else {
            this.$notify({
              type: 'success',
              message: '礼品领取成功！'
            })
            this.queryDreamingActivityRecord()
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        console.log('err')
      })
    },
    // 扫码
    handleScanCode () {
      const checkResult = this.handleVerifyAuth()
      if (!checkResult) return
      if (!this.wxReady) return
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData = {
            scanCode: res.resultStr
          }
          this.getLocation(scanData)
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },
    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.dreamingScan(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },
    dreamingScan (scanData) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.dreamingScan(scanData).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.$set(this.clientRecordList, this.period - 1, res.data.resultData.clientRecord)
          this.popShow = true
          this.popType = 'result'
          this.pop.title = '恭喜您获得50积分'
          this.pop.content = `当月已累计获得<span style="color: #ff4050; vertical-align: baseline;">${this.clientRecordList[this.period - 1].wishQty}</span>点心愿值`
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    handleSupport () {
      const checkResult = this.handleVerifyAuth()
      if (!checkResult) return
      console.log('support')
      this.popShow = true
      this.popType = 'activity'
      this.pop.iconText = '邀'
      this.pop.title = '邀请5位好友助力'
      this.pop.content = '即可获得<span style="color: #ff4050; vertical-align: baseline;">1点</span>点心愿值'
      this.pop.btnText = '喊好友助力'
    },
    handleSupportInvite () {
      this.popShow = false
      this.showOverlay = true
    },
    // 登录验证
    handleVerifyAuth () {
      if (!this.clientInfo) {
        this.$dialog.confirm({
          message: '立即登录参与活动?'
        }).then(() => {
          this.$router.push({
            name: 'login',
            params: { redirectUrl: this.$route.name }
          })
        }).catch(() => {
          console.log('error')
        })
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.base-blue {
  color: #629fde;
}
.padding-top-10 {
  padding-top: 10px;
}
.base-line-height {
  line-height: 20px;
}
.font-size-16 {
  font-size: 16px;
}

.page {
  position: relative;
  min-height: calc(100vh);
  padding-top: 0;
  padding-bottom: 50px;
  background: #162c7b;
  .btn-wapper {
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
    z-index: 10;
    .btn {
      width: 280px;
      height: 40px;
      margin: 0 auto;
      border-radius: 5px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 16px;
      background-image: linear-gradient(#26c2eb, #298ef6);
    }
  }
  img {
    width: 100%;
  }
  .header {
    position: relative;
    padding-bottom: 10px;
  }

  .theme {
    width: 100%;
    text-align: center;
    color: #fff;
    .theme-host {
      img {
        width: 50px;
      }
    }
    .theme-title {
      padding: 10px 0;
      margin: 0 auto;
      img {
        width: 200px;
      }
    }
    .theme-info {
      padding-bottom: 5px;
      font-size: 30px;
      font-weight: 600;
      font-style: italic;
    }
    .theme-time {
      width: 250px;
      height: 50px;
      margin: 0 auto;
      text-align: center;
      line-height: 50px;
      background: no-repeat center url('../../assets/images/activity/dream/title-time-bg.png');
      background-size: 100%;
    }
  }

  .rule {
    font-size: 12px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    .rule-wrapper {
      width: 160px;
      background-color: #fff;
      .color-bar {
        line-height: 30px;
        padding-left: 10px;
        font-weight: 600;
        color: #fff;
        text-align: left;
        background-image: linear-gradient(#26c2eb, #298ef6);
        span:nth-child(1) {
          display: inline-block;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          margin-right: 5px;
          color: #84b7fb;
          border-radius: 10px;
          background: #fff;
        }
      }
      .rule-content {
        position: relative;
        height: 130px;
        padding: 10px;
        text-align: center;
        border-right: 1px solid #84b7fb;
        .rule-content-prize {
          width: 110px;
          height: 80px;
          line-height: 80px;
          margin: auto;
          img {
            position: relative;
            z-index: 2;
            width: 100%;
            vertical-align: middle;
          }
        }
        .rule-content-info {
          font-size: 12px;
          padding: 5px;
          border-radius: 3px;
          color: #f93d34;
          background-color: #ffce3b;
        }
        .rule-content-icon {
          position: absolute;
          top: 0;
          right: 5px;
          color: #fff;
          width: 25px;
          height: 35px;
          background: no-repeat center url('../../assets/images/activity/dream/rule-icon.png');
          background-size: 100%;
          font-weight: 600;
          font-size: 10px;
          padding-top: 5px;
          box-sizing: border-box;
        }
        .rule-content-remark {
          padding-top: 5px;
          font-size: 10px;
        }
      }
    }

  }

  .guide {
    text-align: center;
    .guide-title {
      padding: 30px 0;
      color: #fff;
      img {
        width: 50px;
      }
      span {
        display: inline-block;
        padding: 0 5px;
        font-weight: 600;
        font-size: 16px;
      }
    }

    .guide-map {
      position: relative;
      .map-icon, .map-site {
        position: absolute;
        img {
          position: relative;
          width: 18px;
        }
        .map-icon-light {
          position: absolute;
          bottom: 0;
        }
      }
      .map-icon-one {
        z-index: 2;
        top: 155px;
        right: 35px;
      }
      .map-icon-two {
        z-index: 2;
        top: 153px;
        right: 55px;
      }
      .map-icon-three {
        top: 120px;
        right: 95px;
      }
      .map-icon-four {
        top: 90px;
        right: 75px;
      }
      .map-icon-five {
        top: 145px;
        right: 45px;
      }
      .map-icon-six {
        bottom: 175px;
        right: 75px;
      }

      .map-site {
        font-size: 10px;
        color: #ccc;
        img {
          width: 10px;
          vertical-align: bottom;
        }
      }
      .map-site-one {
        top: 180px;
        right: 10px;
      }
      .map-site-two {
        top: 165px;
        right: 70px;
      }
      .map-site-three {
        top: 130px;
        right: 115px;
      }
      .map-site-four {
        top: 100px;
        right: 8px;
      }
      .map-site-five {
        top: 132px;
        right: 20px;
      }
      .map-site-six {
        bottom: 180px;
        right: 95px;
      }
    }
    .guide-content {
      box-sizing: border-box;
      width: 320px;
      padding: 10px 10px 20px 10px;
      margin: 0 auto ;
      background: #fff;
      border-radius: 8px;
      img {
        width: 250px;
        line-height: 0;
        vertical-align: bottom;
      }
      .guide-btn {
        width: 250px;
        margin: 0 auto;
        line-height: 30px;
        font-weight: 600;
        font-size: 16px;
        border-radius: 5px;
        color: #fff;
        background-image: linear-gradient(#26c2eb, #298ef6);
      }
      .width-130 {
        width: 130px;
      }
      .guide-info {
        line-height: 25px;
        .guide-info-title {
          padding-top: 20px;
          line-height: 30px;
          img {
            width: 25px;
            line-height: 0;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            padding: 0 5px;
            font-size: 16px;
            font-weight: 600;
            vertical-align: middle;
          }
        }
        .guide-way {
          display: flex;
          padding: 5px 0;
          margin-bottom: 20px;
          justify-content: space-between;
          border-bottom: 1px solid #ddd;
        }
      }
      .guide-card {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        box-sizing: border-box;
        // width: 90px;
        height: 150px;
        padding-bottom: 5px;
        line-height: 18px;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        .card-period {
          width: 100%;
          height: 25px;
          line-height: 25px;
        }
        .card-image {
          width: 100%;
          img {
            width: 50px;
            height: 50px;
            margin: 0 auto;
          }
        }
        .card-prize {
          width: 100%;
          height: 20px;
          line-height: 20px;
          font-size: 10px;
          font-weight: 500;
        }
        .card-btn {
          box-sizing: border-box;
          width: 80%;
          height: 20px;
          line-height: 20px;
          margin: 0 auto;
          border: 1px solid #fff;
          border-radius: 10px;
        }
        .card-btn-active {
          border: 0px;
          color: #c25a19;
          background-color: #fae862;
        }
      }
      .guide-card-active {
        // width: 100px;
        height: 165px;
      }

      .progress-bar {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin: 10px 0 20px 0;
        width: 100%;
        height: 80px;
        .progress-bubble {
          width: 100%;
          color: #fff;
          text-align: left;
          span {
            display: inline-block;
            background: no-repeat center url('../../assets/images/activity/dream/icon-bubble.png');
            background-size: 40px 25px;
            width: 40px;
            height: 25px;
            text-align: center;
            line-height: 20px;
            font-size: 10px;
            font-weight: 600;
          }
        }
        .progress-bar-image {
          position: relative;
          width: 40px;
          height: 40px;
          margin: 0 auto;
          text-align: center;
          span {
            position: relative;
            z-index: 2;
            display: inline-block;
            font-size: 10px;
            padding: 5px 0;
            font-weight: 600;
            line-height: 15px;
          }
          img {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 100%;
            z-index: 0;
          }
          .arrow {
            position: absolute;
            top: 50%;
            right: 0;
            z-index: 3;
            img {
              width: 10px;
            }
          }
        }
        div {
          line-height: 30px;
          font-size: 12px;
        }
        .progress-bar-active {
          color: #629fde;
        }
        .progress-bar-mark {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 40px;
          height: 40px;
          border-radius: 20px;
          background-color: #629fde;
          opacity: .6;
          z-index: 3;
        }
      }
      .btn-wrapper {
        display: flex;
        justify-content: space-around;
        padding-top: 20px;
      }
      .guide-share {
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-top: 1px solid #eee;
        img {
          line-height: 60px;
          width: 20px;
          height: 10px;
        }
        .guide-share-tips {
          padding-top: 20px;
          div {
            line-height: 30px;
          }
          img {
            width: 60px;
            height: 60px;
          }
        }
      }
      .rank {
        width: 280px;
        height: 52px;
        div {
          height: 52px;
          line-height: 60px;
          padding-left: 60px;
          text-align: left;
          font-weight: 600;
          font-size: 20px;
          color: #fff;
        }
      }
      .rank-first {
        background: no-repeat center url('../../assets/images/activity/dream/top1.png');
        background-size: 100%;
      }
      .rank-second {
        background: no-repeat center url('../../assets/images/activity/dream/top2.png');
        background-size: 100%;
      }
      .rank-third {
        background: no-repeat center url('../../assets/images/activity/dream/top3.png');
        background-size: 100%;
      }

      .icon-prize {
        display: inline-block;
        width: 300px;
        padding: 20px 0;
      }

    }
    .activity-details {
      padding-top: 15px;
      line-height: 25px;
      text-align: left;
      .activity-title {
        padding: 10px 0;
      }
    }

  }

  .van-popup {
    width: 270px;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0);
    .pop-content {
      padding: 30px 20px;
      text-align: center;
      border-radius: 10px;
      background-color: #fff;
      .pop-content-img {
        // width: 200px;
        margin: 20px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .pop-content-title {
        line-height: 30px;
        font-size: 20px;
        font-weight: 600;
      }
      .pop-content-info {
        line-height: 20px;
        text-align: left;
        .pop-info-title {
          padding: 20px 0;
          text-align:center;
          color: #999;
        }
        .pop-info-content {
          padding-bottom: 20px;
          text-align:center;
        }
      }
      .pop-content-btn {
        padding-top: 20px;
        .button-line {
          height: 35px;
          line-height: 35px;
          margin: 0 50px;
          font-weight: 400;
          background-color: rgba(52, 122, 127, 1);
        }
      }

      .pop-header {
        img {
          width: 40px;
        }
        span {
          display: inline-block;
          width: 50px;
          height: 50px;
          margin: 0 20px;
          line-height: 50px;
          border-radius: 25px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          background: #fa5657;
        }
      }
      .pop-btn {
        width: 180px;
        height: 35px;
        margin: 0 auto;
        line-height: 35px;
        font-size: 16px;
        color: #fff;
        border-radius: 10px;
        background: #162c7b;
      }
    }
    .pop-content-result {
      position: relative;
      padding-top: 60px;
      margin-top: 80px;
      .pop-header-result {
        position: absolute;
        top: -60px;
        left: 0;
        right: 0;
        width: 150px;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
    }
    .pop-close {
      width: 39px;
      height: 39px;
      margin: 32px auto 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .overlay-wrapper {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    height: 100%;
    line-height: 120px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    .arrow {
      padding-left: 10px;
      width: 80px;
    }
  }
  .site-active {
    color: #fff
  }
}
</style>
